/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Sso({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M14.942 5.478a3.1 3.1 0 0 1-3.92.383L8.885 8l1.23 1.23a.6.6 0 0 1-.848.85l-1.23-1.231-1.344 1.343a.6.6 0 0 1-.849-.849l4.331-4.33a3.101 3.101 0 1 1 4.768.465m-3.536-3.536a1.9 1.9 0 1 1 2.687 2.687 1.9 1.9 0 0 1-2.687-2.687" clipRule="evenodd" /><path fill="currentColor" d="M8 2.6A2.4 2.4 0 0 0 5.6 5v.9h.9a.6.6 0 0 1 0 1.2H4a1.4 1.4 0 0 0-1.4 1.4v5c0 .22.18.4.4.4h10a.4.4 0 0 0 .4-.4V8a.6.6 0 1 1 1.2 0v5.5a1.6 1.6 0 0 1-1.6 1.6H3a1.6 1.6 0 0 1-1.6-1.6v-5A2.6 2.6 0 0 1 4 5.9h.4V5A3.6 3.6 0 0 1 8 1.4a.6.6 0 0 1 0 1.2" /></svg>;
}
;